import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscussionTotalReportComponent } from './discussion-total-report.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ReportsComponentModule } from 'app/views/reports-component/reports-component.module';
import { SharedModule } from 'app/_shared/shared.module';
import { ChartsModule } from 'ng2-charts';
import { CKEditorModule } from 'ng2-ckeditor';
import { Daterangepicker } from 'ng2-daterangepicker';
import { TabsModule, BsDatepickerModule } from 'ngx-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { DiscussionTotalReportService } from './discussion-total-report.service';

const routes: Routes = [
  {
    path: '',
    component: DiscussionTotalReportComponent,
    data: {
      title: 'Báo cáo tổng lượng thảo luận'
    },
  }
];
@NgModule({
  imports: [
    ChartsModule,
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    ReportsComponentModule,
    CKEditorModule,
    NgxPaginationModule
  ],
  declarations: [DiscussionTotalReportComponent],
  providers: [DiscussionTotalReportService]
})
export class DiscussionTotalReportModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/discussion-total-report/discussion-total-report.module.ts